import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomInput } from '../../utilComponents/inputs/CustomInput';
import { validateInput } from '../../../helpers/validateInput';

export const ObservationsStep = ({ form, handleUpdateForm }) => {
    const [touchedFields, setTouchedFields] = useState({});

    const validateField = (name, value) => {
        return validateInput(name, value, form);
    };

    const handleFieldChange = (field, value) => {
        handleUpdateForm(field, value);
        setTouchedFields({ ...touchedFields, [field]: true });
    };

    return (
        <Box mb={4}>
            <Typography variant="h6" sx={{ marginBottom: '10px' }}>
                Paso 5: Observaciones
            </Typography>
            <CustomInput
                label="Observaciones"
                value={form.observations}
                onChange={({ target }) =>
                    handleFieldChange('observations', target.value)
                }
                error={
                    touchedFields.observations &&
                    !!validateField('observations', form.observations)
                }
                helperText={
                    touchedFields.observations &&
                    validateField('observations', form.observations)
                }
                multiline
                rows={4}
            />
        </Box>
    );
};
